"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var material_1 = require("@mui/material");
var ConnectionStyles_1 = require("@/frontend/react/connections/ConnectionStyles");
var trans_1 = __importDefault(require("@/plugins/trans"));
var useIsMobileFullScreen_1 = __importDefault(require("@/frontend/react/hooks/useIsMobileFullScreen"));
var useIsSmallScreen_1 = __importDefault(require("@/frontend/react/hooks/useIsSmallScreen"));
var ChatsList_1 = __importDefault(require("./ChatsList"));
function ChatsPage() {
    var isSmallScreen = (0, useIsSmallScreen_1.default)();
    var isMobileFullScreen = (0, useIsMobileFullScreen_1.default)();
    return ((0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ container: true, spacing: isSmallScreen ? 0 : 5, sx: { marginLeft: 0, width: '100%' } }, { children: [(0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 12, display: isMobileFullScreen ? 'none' : 'block', sx: ConnectionStyles_1.containerStyles.titlePage }, { children: (0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ variant: "h3", color: "secondary", fontWeight: "bold" }, { children: trans_1.default.get('connections.chats.title') })) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 12, md: 4, sx: { display: isMobileFullScreen ? 'none' : 'block', margin: { xs: 3, md: 0 } } }, { children: (0, jsx_runtime_1.jsx)(ChatsList_1.default, {}) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 12, md: 8 }, { children: (0, jsx_runtime_1.jsx)(react_router_dom_1.Outlet, {}) }))] })));
}
exports.default = ChatsPage;
